import { render, staticRenderFns } from "./InformeAuditoriaView.vue?vue&type=template&id=6804aff4&"
import script from "./InformeAuditoriaView.vue?vue&type=script&lang=js&"
export * from "./InformeAuditoriaView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports